import type { ThemeAnimationTokens } from "@yamada-ui/core"

export const animations: ThemeAnimationTokens = {}
